import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { FlowControlNarrowViewMode } from '@/types/player/flow-control-narrow-view.types';

type FlowControlNarrowViewState = {
  mode: FlowControlNarrowViewMode;
  setMode: (mode: FlowControlNarrowViewMode) => void;
};

export const useFlowControlNarrowViewStore = create<FlowControlNarrowViewState>()(
  persist(
    (set) => ({
      mode: 'list',
      setMode: (mode) => set({ mode }),
    }),
    {
      name: 'flow-control-narrow-view',
    },
  ),
);
